<template>
  <div class="main-gis-wms-map">
    <div class="content-gis-map">
      <div :id="`${nameMap}_${initialDate}`" :style="minHeight" />
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '@fortawesome/fontawesome-free';
import { mapState, mapActions } from 'vuex';
import EventBus from '@/services/event-bus';
import Api from '../../../services/Api';

export default {
  name: 'GISWMSMap',
  props: {
    zoom: { type: Number, default: 1 },
    height: { type: String, default: '80vh' },
    nameMap: { type: String, default: '' },
    index: { type: String, default: 'NDVI' },
    layer: {
      type: Object,
      default: () => {},
    },
    center: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentLayerBase: {},
      map: null,
      initialDate: Date.now(),
      currentLayers: [],
      textbox: null,
      currentDate: null,
      currentIndex: null,
    };
  },
  computed: {
    minHeight() {
      return `min-height: ${this.height}`;
    },
    ...mapState('gis', [
      'osm',
      'currentOverlayLayer',
      'featureInfo',
      'datesList',
    ]),
  },
  beforeMount() {
    setTimeout(() => {
      EventBus.$on(`indexLayer${this.nameMap}`, this.indexLayer);
      EventBus.$on(`updateDateLayer${this.nameMap}`, this.dateLayer);
    }, 0);
  },
  beforeDestroy() {
    EventBus.$off(`indexLayer${this.nameMap}`);
    EventBus.$off(`updateDateLayer${this.nameMap}`);
  },
  mounted() {
    this.setCurrentLayersMap([]);
    this.renderMap();
    this.addFuncionalities();
    this.addOverlayLayer();
    // this.updateLayer();
    this.indexLayer(this.index);
  },
  methods: {
    getMapStyleParams(index) {
      const style = index || this.currentIndex || this.index || 'NDVI';

      return {
        styles: style,
      };
    },

    getLayerName(layerValue = this.layer?.options?.layers) {
      return Api.normalizeGISLayerId(layerValue);
    },

    /**
     * Añadimos una capa tanto de tipo GeoJson como WMS a la lista de capas activas
     */
    async addOverlayLayer() {
      this.$f7.preloader.show();
      try {
        const layer = Api.createWmsLayer(
          L,
          this.layer.baseUrl,
          this.layer.options
        );
        this.map.setView(
          [this.center.latitude, this.center.longitude],
          this.zoom
        );

        const item = this.layer;
        this.currentLayers.push({ item, layer });
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },

    indexLayer(index) {
      this.currentLayers[0].layer
        .setParams(this.getMapStyleParams(index))
        .addTo(this.map);

      this.currentIndex = index;

      const layerName = this.getLayerName();

      if (!layerName) {
        this.map.legend.setContent('');
        return;
      }

      let legendContent = `<h6 class="legend-index-name">${index}</h6><img src=${Api.getGeoServerProjectWorkSpace()}REQUEST=GetLegendGraphic&VERSION=2.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=10&LAYER=${layerName}&style=${index}&legend_options=fontName:Times%20New%20Roman;fontAntiAliasing:true;fontColor:0x000033;fontSize:8;bgColor:0xFFFFFF;dpi:91&SCALE=1001; style="opacity:0.8";>`;

      if (index !== 'TCI') {
        this.map.legend.setContent(legendContent);
        const indexNameClass = document.getElementsByClassName(
          'legend-index-name'
        );

        if (
          index === 'NDMI' ||
          index === 'VARI' ||
          index === 'RECI'
        ) {
          indexNameClass[0].style.width = '40px';
          indexNameClass[0].style.top = '-46px';
        } else {
          indexNameClass[0].style.width = '37px';
        }
      } else {
        legendContent = '';
        this.map.legend.setContent(legendContent);
      }
    },

    dateLayer(date) {
      this.currentLayers[0].layer
        .setParams({
          time: date,
        })
        .addTo(this.map);
      const newFormatDate = this.formatDate(date);
      this.addTimeTextToMap(newFormatDate);
      this.currentDate = date;
    },

    /**
     * Anidamos los datos para adjuntar en la ruta.
     */
    generateRouteTocenterMapWMSLayer(item) {
      const layerName = this.getLayerName(item.options.layers);
      if (!layerName) return '';
      const fullUrl = `layer_bounds?client=${Api.getGeoServerWorkspace()}&ws=${Api.getGeoServerWorkspace()}&layer=${layerName}&ds=${item.ds}`;
      return fullUrl;
    },

    /**
     *
     */
    async dataRequestWMSLayers(route, e) {
      await this.fetchFeatureInfo({ queryParams: `wms/${route}` });
      if (
        !('features' in this.featureInfo) ||
        !this.featureInfo.features.length
      ) {
        // return false;
      } else {
        const features = this.featureInfo.features[0];
        const { properties } = features;

        this.openLayerDataPopup(properties, e);
      }
    },

    /**
     *
     */
    generateRouteToDataRequestWMSLayers(item, e) {
      const BBOX = `${e.latlng.lng - 0.00002},${
        e.latlng.lat - 0.00002
      },${e.latlng.lng + 0.00002},${e.latlng.lat + 0.00002}`;

      const queryParams = {
        REQUEST: 'GetFeatureInfo',
        SRS: 'EPSG:4326',
        BBOX,
        HEIGHT: this.map.getSize().y,
        WIDTH: this.map.getSize().x,
        LAYERS: item,
        DATE: this.currentDate,
        QUERY_LAYERS: item,
        INFO_FORMAT: 'application/json',
        X: Math.round(
          this.map.layerPointToContainerPoint(e.layerPoint).x
        ),
        Y: Math.round(
          this.map.layerPointToContainerPoint(e.layerPoint).y
        ),
      };

      const fullUrl = L.Util.getParamString(queryParams);
      this.dataRequestWMSLayers(fullUrl, e);
    },

    async updateLayer() {
      this.$f7.preloader.show();
      try {
        const currentOverlayLayer = this.getLayerName(
          this.layer.options.layers
        );
        await this.fetchDatesLayer(currentOverlayLayer);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
        const lastDate = this.datesList.avaiable_dates.pop();
        const newFormatDate = this.formatDate(lastDate);
        this.addTimeTextToMap(newFormatDate);
      }
    },

    formatDate(date) {
      const dateObject = new Date(date);
      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1;
      const year = dateObject.getFullYear();
      const newFormatDate = `${day}/${month}/${year}`;
      return newFormatDate;
    },

    renderMap() {
      this.map = L.map(`${this.nameMap}_${this.initialDate}`, {
        minZoom: 12,
        maxZoom: 18,
      });
      L.tileLayer(
        this.osm.googleHybrid.route,
        this.osm.googleHybrid.properties
      ).addTo(this.map);
      this.currentLayerBase = L.tileLayer(
        this.osm.googleHybrid.route,
        this.osm.googleHybrid.properties
      ).addTo(this.map);
      this.currentLayerBase.bringToBack();
      this.setMapEvents();
    },

    addFuncionalities() {
      const self = this;
      try {
        L.control.scale().addTo(self.map);
        self.map.attributionControl.addAttribution(
          'Thäles from <a href="https://hispatecanalytics.com//">HispatecAnalytics SA</a>'
        );
        L.Control.zoomHome = L.Control.extend({
          options: {
            position: 'topleft',
            zoomHomeText:
              '<i class="fa fa-home" style="line-height:1.65 blue;"></i>',
            zoomHomeTitle: 'Zoom home',
          },
          onAdd() {
            const controlName = 'gin-control-zoom';
            const container = L.DomUtil.create(
              'div',
              `${controlName} leaflet-bar`
            );
            const { options } = this;
            this.zoomHomeButton = this.createButton(
              options.zoomHomeText,
              options.zoomHomeTitle,
              `${controlName}-home`,
              container,
              this.zoomHome
            );

            return container;
          },

          zoomHome() {
            self.map.setView(
              [self.center.latitude, self.center.longitude],
              self.zoom
            );
          },

          createButton(html, title, className, container, fn) {
            const link = L.DomUtil.create('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            L.DomEvent.on(
              link,
              'mousedown dblclick',
              L.DomEvent.stopPropagation
            )
              .on(link, 'click', L.DomEvent.stop)
              .on(link, 'click', fn, this);
            return link;
          },
        });
        // eslint-disable-next-line new-cap
        const zoomHome = new L.Control.zoomHome();
        zoomHome.addTo(self.map);

        L.Control.legend = L.Control.extend({
          options: {
            position: 'bottomright',
          },
          onAdd() {
            self.map.legend = this;

            const container = L.DomUtil.create(
              'div',
              'legend-control-container'
            );

            if (this.options.content) {
              container.innerHTML = this.options.content;
            }
            return container;
          },
          onRemove() {
            delete self.map.legend;
          },

          setContent(str) {
            this.getContainer().innerHTML = str;
          },
        });
        // eslint-disable-next-line new-cap
        const legend = new L.Control.legend();
        legend.addTo(self.map);
      } catch (e) {
        this.$f7.dialog.alert(e);
      }
    },
    addTimeTextToMap(date) {
      const self = this;
      L.Control.textbox = L.Control.extend({
        options: {
          position: 'topright',
        },
        onAdd() {
          const text = L.DomUtil.create('div');
          text.id = 'info_text';
          text.innerHTML = `<strong>${date.fontcolor(
            'white'
          )}</strong>`;
          return text;
        },
      });
      if (self.textbox !== null) {
        self.textbox.remove(self.map);
      }
      self.textbox = new L.Control.textbox();
      self.textbox.addTo(self.map);
    },
    openLayerDataPopup(properties, e, extra = {}) {
      let htmlString = "<div class='popup-content'>";
      htmlString += extra.before || '';
      let listHtml = '<ul>';
      listHtml += this.getLayerDataPropertiesHtml(properties);
      listHtml += '</ul>';
      htmlString += `${listHtml}</div>`;
      htmlString += extra.after || '';
      this.openPopup(htmlString, e.latlng);
    },
    getLayerDataPropertiesHtml(properties) {
      let listHtml = '';
      const bands = 'Band1';
      let result = 0;
      if (bands in properties) {
        switch (this.currentIndex) {
          case 'NDVI':
            result =
              (properties.Band8 - properties.Band4) /
              (properties.Band8 + properties.Band4);
            break;
          case 'SAVI':
            result =
              ((properties.Band8 - properties.Band4) /
                (properties.Band8 + properties.Band4 + 0.428)) *
              0.428;
            break;
          case 'GNDVI':
            result =
              (properties.Band8 - properties.Band3) /
              (properties.Band8 + properties.Band3);
            break;
          case 'ARVI':
            result =
              (properties.Band8 -
                0.106 * properties.Band4 +
                properties.Band2) /
              (properties.Band8 +
                0.106 * properties.Band4 +
                properties.Band2);
            break;
          case 'AVI':
            result =
              (properties.Band8 *
                (1 - properties.Band4) *
                (properties.Band8 - properties.Band4)) **
                1 /
              3;
            break;
          case 'EVI':
            result =
              2.5 *
              ((properties.Band8 - properties.Band4) /
                (properties.Band8 +
                  6 * properties.Band4 -
                  7.5 * properties.Band2 +
                  1));
            break;
          case 'VARI':
            result =
              (properties.Band3 - properties.Band4) /
              (properties.Band3 +
                properties.Band4 -
                properties.Band2);
            break;
          case 'LAI':
            result =
              0.57 **
              (2.33 *
                ((properties.Band8 - properties.Band4) /
                  (properties.Band8 + properties.Band4)));
            break;
          case 'NDRE':
            result =
              (properties.Band8 - properties.Band5) /
              (properties.Band8 + properties.Band5);
            break;
          case 'RECI':
            result =
              (properties.Band8 - properties.Band11) /
              (properties.Band8 + properties.Band11);
            break;
          case 'NDMI':
            result =
              properties.Band8 /
              (properties.Band8 + properties.Band11);
            break;
          case 'MSI':
            result = properties.Band11 / properties.Band8;
            break;
          case 'GCI':
            result = properties.Band9 / properties.Band3 - 1;
            break;
          case 'NBRI':
            result =
              properties.Band8 /
              (properties.Band8 + properties.Band2);
            break;
          default:
          case 'BSI':
            result =
              properties.Band11 +
              properties.Band4 -
              (properties.Band8 + properties.Band2) /
                (properties.Band11 + properties.Band4) +
              (properties.Band8 + properties.Band2);
            break;
        }
        listHtml += `<li><b>${
          this.currentIndex
        }</b>: ${result.toFixed(2)}</li>`;
      } else {
        for (const property in properties) {
          if (properties[property] == null) continue;
          if (typeof properties[property] === 'object') {
            listHtml += this.getLayerDataPropertiesHtml(
              properties[property]
            );
          } else {
            listHtml += `<li><b>${property}</b>: ${properties[property]}</li>`;
          }
        }
      }
      return listHtml;
    },
    openPopup(html, latlng) {
      this.map.openPopup(html, latlng, {
        maxHeight: 4000,
      });
    },
    /**
     *
     */
    setMapEvents() {
      const self = this;
      this.map.on('click', (e) => {
        if (this.currentLayers.length < 1) return;
        const layerId = this.getLayerName(
          this.currentLayers[0].item.options.layers
        );
        self.generateRouteToDataRequestWMSLayers(layerId, e);
      });
    },
    ...mapActions('gis', [
      'setCurrentLayersMap',
      'setCurrentOverlayLayer',
      'fetchFeatureInfo',
      'fetchDatesLayer',
    ]),
  },
};
</script>
<style scoped lang="scss">
@import './Map.styles.scss';
@import url('https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css');
</style>
